import React from 'react';
import GoogleMapReact from 'google-map-react';
import ImageMarker from './../../images/logo_map_marker.svg';
import styled from 'styled-components';

const StyledImage = styled.img`
  width: 60px;
`;

const MapMarker = ({ image }) => (
  <StyledImage
    src={image}
    style={
      {
        // position: 'absolute',
        // transform: 'translate(-50%, -50%)',
      }
    }
  />
);

const apiIsLoaded = (map, maps) => {
  map.setOptions({
    // zoom: 17,
    mapTypeControl: false,
    disableDefaultUI: false,
    // scrollwheel: false,
    fullscreenControl: false,
    styles: [
      { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#263c3f' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6b9a76' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#38414e' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#212a37' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9ca5b3' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#746855',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#1f2835',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#f3d19c',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#2f3948',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#d59563',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#17263c',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#515c6d',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#17263c',
          },
        ],
      },
    ],
  });
};

const Map = () => (
  <>
    <div id='map' style={{ width: '100%', height: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAP_API_KEY }}
        // bootstrapURLKeys={{ key: 'AIzaSyAsVworRMW_iho1wgblPrlWtFwIzBj12LU' }}
        defaultZoom={17}
        defaultCenter={{ lat: 54.193661, lng: 16.202965 }}
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}>
        <MapMarker lat={54.193661} lng={16.202965} image={ImageMarker} />
      </GoogleMapReact>
    </div>
  </>
);

export default Map;
